<template>
  <div class="init-loading">
    <v-toolbar
      v-if="!embeddedMode"
      color="primary"
      class="transparent-border-b"
      extension-height="48"
      dark
      dense
    >
      <div
        class="header-container container pt-0"
        style="height: 100%;width: 100%;"
      >
        <v-toolbar-items style="width: 100%;align-items: center;">
          <v-toolbar-title
            :style="[$vuetify.breakpoint.mdAndUp ? 'align-self:center;' : '']"
            class="transparent-border"
          >
            <AppEquastrianLogo />
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar-items>
      </div>
    </v-toolbar>
    <template v-if="!embeddedMode && $vuetify.breakpoint.mdAndUp">
      <div
        class="front-page-main-banner hidden-sm-and-down muted"
        role="header"
        style="height: 370px;"
      ></div>
      <nav class="tertiary elevation-2" style="height: 48px;">
        <div class="container" style="height: 100%;"></div>
      </nav>
    </template>
    <v-container class="d-flex justify-center" style="min-height: 50vh;">
      <div
        data-test="settingThingsUp"
        class="text-center"
        style="height: 100%; min-height: 25vh;align-self: center;"
      >
        <template v-if="error">
          <v-icon color="secondary" style="font-size: 6em;"
            >$iconExclamationTriangle</v-icon
          >
        </template>
        <template v-else>
          <v-progress-circular
            indeterminate
            width="8"
            size="160"
            color="muted"
            :class="$vuetify.breakpoint.mdAndDown ? 'mt-10' : ''"
            style="overflow: hidden;"
          />
        </template>
        <h1 class="mt-8 pt-5 loading-text-size">
          {{
            $i18next.isInitialized
              ? customText || $t("common:settingThingsUp.message", " ")
              : ""
          }}
        </h1>
        <template v-if="error">
          <v-btn
            x-large
            class="mt-8 pa-6"
            width="15em!important"
            height="auto!important"
            @click="reload"
          >
            <v-icon class="mr-3">$iconRefresh</v-icon>
            {{ $t("common:reload.button") }}
          </v-btn>
        </template>
      </div>
    </v-container>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import AppEquastrianLogo from "@elements/AppEquastrianLogo.vue";
//import AppHeroBanner from "@elements/banners/AppHeroBanner";

export default defineComponent({
  name: "InitLoad",
  components: { AppEquastrianLogo },
  inject: ["embeddedMode"],
  props: {
    customText: {
      type: [Error, String],
      default: ""
    },
    error: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    webpDisabled: () => Boolean(document.querySelector(".no-webp")),
    styleImage() {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "max-width:3840px;height:370px;";
      } else {
        return "width: 100%;max-width:375px;height:375px;";
      }
    },
    loading() {
      if (this.error) return false;
      else return true;
    },
    publicMenuItems() {
      return [
        {
          routeName: "Calendar",
          linkTranslationKey: "navigation:menu.calendar",
          linkName: "Calendar"
        },
        {
          routeName: "HorsesSearchPage",
          linkTranslationKey: "navigation:menu.horses",
          linkName: "Horses"
        },
        {
          routeName: "OrganisationsSearchPage",
          linkTranslationKey: "navigation:menu.organisations",
          linkName: "Organisations"
        },
        {
          routeName: "Support",
          linkTranslationKey: "navigation:menu.support",
          linkName: "Support"
        }
      ];
    }
  },
  methods: {
    reload() {
      location.reload();
    }
  }
});
</script>

<style lang="scss" scoped>
.init-loading {
  filter: grayscale(25%);
}

.loading-text-size {
  @media (max-width: 578px) {
    font-size: 1.6rem;
  }
}
.front-page-main-banner {
  background-color: snow;
  object-fit: cover;

  &-FI img {
    object-position: 0 bottom;
  }

  img {
    width: 100%;
    object-fit: cover;
  }
}
.boxes {
  display: flex;
  margin: 0 4px;
  .box-seperator {
    width: 1px;
    height: 18px;
    background-color: rgba(255, 255, 255, 0.6);
    margin: 0 6px;
    opacity: 0.7;
    align-self: center;
  }

  .box {
    background: darkgray;
    opacity: 0.2;
    min-height: 30px;
    border-radius: 5px;
    margin: 0 2px;

    animation-name: loading;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
  }
}

@keyframes loading {
  0% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.85;
  }
  100% {
    opacity: 0.2;
  }
}

.mobile-menu-btn {
  align-items: center;
  height: 48px;
  width: 100%;
  padding: 0 1em;
  text-align: left;
  font-size: 18px;
}
.mobile-menu-list {
  padding: 0 28px;

  &:hover {
    background: white;
    b {
      color: #771e24 !important;
    }
  }
  b {
    display: flex;
    align-items: center;
  }
  border-bottom: 2px solid white;
}
.unisearch-box {
  background: white;
  border: 1px solid #d3733c;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
}
.unisearch-box .theme--dark.v-icon {
  color: #d3733c;
}

#userDialog {
  margin: auto;
}
.logo {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  z-index: 100;
  width: 133px;
  height: 176px;
  padding: 16px;
  background: #1269b0;
  img {
    margin-top: 35px;
    width: 100px;
    height: 100px;
  }
}
.logo-mobile {
  max-width: 100%;
  display: block;
  height: 36px;
}
.login-dialog {
  padding: 1em;
  position: absolute;
  width: inherit;
}
#loginDialog {
  margin: auto;
}
#loginBtn {
  min-width: 160px;
  height: 30px !important;
  min-height: 30px !important;
  text-transform: none;
  .v-btn__content {
    height: 30px !important;
    i {
      position: absolute;
      left: 0px;
      font-size: 20px !important;
    }
  }
}

#loginDialogBox > a.btn {
  border-radius: 20px;
}
@media (max-width: 960px) {
  .header-container {
    padding-top: 0 !important;
  }

  .toolbarcontent {
    padding: 0px;
  }
  .login-dialog {
    position: fixed;
    top: 48px !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    border-radius: 0 !important;
    &-content {
      padding: 28px 48px;
      height: 100%;
    }
  }
  .fixedtoolbar {
    position: fixed !important;
    padding: 0 !important;
    top: 0;
    width: 100%;
  }
}
.admin-mobile > .activator-admin-mobile {
  color: white;
  align-self: center;
  display: flex;
  justify-content: center;
}
</style>
